import { delay } from 'Common/utils';
import data from './data';

export const fetchConsulates = () => {
  return delay(500).then(() => {
    return data;
  });
};

export const submitApplication = (value, cb) => {
  return delay(500).then(() => ({
    ok: true,
    body: {
      status: true,
      message: 'success',
      result: {
        request_id: '15-f/18',
        token: '80d57dc4ac',
      },
    },
  }));
};

export default {
  fetchConsulates,
  submitApplication,
};



// WEBPACK FOOTER //
// ./src/apps/consulates/fake-api/api.js